import { render } from "./articleDetailv3.vue?vue&type=template&id=52128908&scoped=true"
import script from "./articleDetailv3.vue?vue&type=script&lang=js"
export * from "./articleDetailv3.vue?vue&type=script&lang=js"

import "./articleDetailv3.vue?vue&type=style&index=0&id=52128908&lang=scss&scoped=true"
import "./articleDetailv3.vue?vue&type=style&index=1&id=52128908&lang=scss"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52128908"]])

export default __exports__